module.exports = ":host {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1; }\n\nform {\n  position: relative; }\n\nform .form-error {\n    position: absolute;\n    top: -2rem;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%); }\n\nform .btn {\n    width: 100%; }\n\nform .text-muted {\n    line-height: 1.2;\n    text-align: center; }\n\na.recruit-link {\n  color: #00f; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = ./src/app/login/login.component.scss
// module chunks = main